// DepartmentGroupBarCompare.jsx
import React, { useState, useMemo, useEffect } from "react";
import { Bar } from "react-chartjs-2";
import "./departmentCompare.css";


export default function DepartmentGroupBarCompare({ data = [] }) {
  // const chartRef = useRef(null);
  // const [chartRefreshKey, setChartRefreshKey] = useState(0);


  //-----------------------------
  // Memos
  //-----------------------------

// const refreshChart = () => {
//   setChartRefreshKey((k) => k + 1);
// };


  // ----------------------------
  // LEVEL LIST
  // ----------------------------
  const allLevels = useMemo(() => {
    return ["All", ...new Set(data.map((d) => d.level || "Unknown"))];
  }, [data]);

  const [selectedLevel, setSelectedLevel] = useState("All");



  // ----------------------------
  // FILTER DATA BY LEVEL
  // ----------------------------
  const filteredData =
    selectedLevel === "All"
      ? data
      : data.filter((d) => d.level === selectedLevel);

  // ----------------------------
  // EXTRACT DEPARTMENTS
  // ----------------------------
  
const departments = useMemo(() => {
  if (selectedLevel === "All") {
    return [...new Set(filteredData.map(d => d.department))]; // unique only
  }
  return filteredData.map(d => d.department); // normal behavior
}, [filteredData, selectedLevel]);


  // ----------------------------
  // EXTRACT GROUPS
  // ----------------------------
  const allGroups = useMemo(() => {
    if (!filteredData.length) return [];

    const set = new Set();
    filteredData.forEach((d) => {
      d.groups.forEach((g) => set.add(g.group));
    });

    return Array.from(set);
  }, [filteredData]);

  // ----------------------------
  // UI STATE
  // ----------------------------
  const [selectedDepts, setSelectedDepts] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [mode, setMode] = useState("positive");
  const [valueType, setValueType] = useState("percent"); // "percent" | "count"


  // ----------------------------
  // RESET DEPTS ON LEVEL CHANGE
  // ----------------------------

  useEffect(() => {
  const next = [...departments]; // the fixed unique dept list
  setSelectedDepts(next);
}, [selectedLevel, departments]);

// useEffect(() => {
//   // When level changes, reset departments ONLY ONCE
//   const nextDepts =
//     selectedLevel === "All"
//       ? data.map(d => `${d.department} (${d.level || "Unknown"})`)
//       : data
//           .filter(d => d.level === selectedLevel)
//           .map(d => d.department);

//   setSelectedDepts([...new Set(nextDepts)]);
// }, [selectedLevel]); // ✅ ONLY level


// useEffect(() => {
//   const groups =
//     selectedLevel === "All"
//       ? data.flatMap(d => d.groups.map(g => g.group))
//       : data
//           .filter(d => d.level === selectedLevel)
//           .flatMap(d => d.groups.map(g => g.group));

//   setSelectedGroups([...new Set(groups)]);
// }, [selectedLevel]); // ✅ ONLY level




  // ----------------------------
  // INIT GROUP SELECTION
  // ----------------------------
// useEffect(() => {
//   if (allGroups.length) setSelectedGroups(allGroups);
// }, [allGroups]);


// useEffect(() => {
//   if (chartRef.current) {
//     chartRef.current.destroy();
//     chartRef.current = null;
//   }
// }, [
//   valueType,
//   mode,
//   selectedLevel,
//   selectedDepts.join("|"),
//   selectedGroups.join("|"),
// ]);


// useEffect(() => {
//   if (chartRef.current) {
//     chartRef.current.options.scales.y.max =
//       valueType === "percent" ? 100 : undefined;
//   }
// }, [valueType]);

  // ----------------------------
  // ACTIONS
  // ----------------------------
  const toggleDept = (dept) =>
    setSelectedDepts((s) =>
      s.includes(dept) ? s.filter((x) => x !== dept) : [...s, dept]
    );

  const toggleGroup = (grp) =>
    setSelectedGroups((s) =>
      s.includes(grp) ? s.filter((x) => x !== grp) : [...s, grp]
    );

  const selectAllDepts = () => setSelectedDepts(departments.slice());
  const deselectAllDepts = () => setSelectedDepts([]);
  const selectAllGroups = () => setSelectedGroups(allGroups.slice());
  const deselectAllGroups = () => setSelectedGroups([]);

  // ----------------------------
  // COLORS
  // ----------------------------
  const POS_COLOR = "#A81026";
  const NEG_COLOR = "#326AB3";
  const palette = [
    "#A81026", "#F3AC26", "#F15C41", "#326ab3",
    "#6C6E2E", "#3B231E", "#4CBFAB", "#29002D",
  ];

  // ----------------------------
  // 🚀 FAST LOOKUP MAP (PERFORMANCE FIX)
  // ----------------------------
  const hardReloadKey = useMemo(() => {
  return `chart-${valueType}-${mode}`;
}, [valueType, mode]);

const dataMap = useMemo(() => {
  const map = {};

  filteredData.forEach(d => {
    const deptName = selectedLevel === "All"
      ? d.department
      : d.department;

    if (!map[deptName]) map[deptName] = {};

    d.groups.forEach(g => {

      if (!map[deptName][g.group]) {
        map[deptName][g.group] = {
          // aggregated buckets
          positive_count: 0,
          negative_count: 0,
          total: 0,

          // original fields for non-All mode
          orig_positive_percent: g.positive_percent || 0,
          orig_negative_percent: g.negative_percent || 0,
        };
      }

      // accumulate counts when level=All
      map[deptName][g.group].positive_count += g.positive_count || 0;
      map[deptName][g.group].negative_count += g.negative_count || 0;
      map[deptName][g.group].total +=
  (g.total_responses ??
   g.positive_count + g.negative_count ??
   0);

    });
  });

  // FINAL CALCULATION FOR PERCENT
  Object.values(map).forEach(groups => {
    Object.values(groups).forEach(g => {

      // If Level = All → derive % from combined counts
      if (selectedLevel === "All") {
      const base = g.total || (g.positive_count + g.negative_count);

g.positive_percent = base
  ? Number(((g.positive_count / base) * 100).toFixed(1))
  : 0;

g.negative_percent = base
  ? Number(((g.negative_count / base) * 100).toFixed(1))
  : 0;

      } else {
        // If a specific level selected → use original backend %
        g.positive_percent = Number(g.orig_positive_percent) || 0;
        g.negative_percent = Number(g.orig_negative_percent) || 0;
      }
    });
  });

  return map;
}, [filteredData, selectedLevel]);


      const chartKey = useMemo(() => {
  return [
    selectedLevel,
    mode,
    valueType,
    selectedDepts.join("|"),
    selectedGroups.join("|"),
  ].join("__");
}, [selectedLevel, mode, valueType, selectedDepts, selectedGroups]);

  // ----------------------------
  // BUILD CHART DATA
  // ----------------------------
  const chartData = useMemo(() => {

    const labels = selectedGroups.slice();

    // ✅ SIMPLE MODE
    if (mode === "positive" || mode === "negative") {
      return {
        labels,
        datasets: selectedDepts.map((dept, idx) => {

          const cleanDeptKey = selectedLevel === "All"
  ? dept.replace(/\s*\(.*?\)\s*$/, "")
  : dept;

        const series = labels.map(grp => {
  const g = dataMap[cleanDeptKey]?.[grp];
  
  if (!g) return 0;
  
  return mode === "positive"
    ? valueType === "percent" ? g.positive_percent : g.positive_count
    : valueType === "percent" ? g.negative_percent : g.negative_count;
});

return {
  label: dept,
  data: series,
  backgroundColor: palette[idx % palette.length],
  datasetIdKey: `${dept}-${mode}-${valueType}`,

  // 🔧 FIX VISUAL COLLAPSE
  maxBarThickness: 42,
  categoryPercentage: 0.85,
  barPercentage: 0.9,
};



        }),
      };
    }

    // ✅ STACKED MODE
    const datasets = [];

    selectedDepts.forEach((dept) => {

      const baseDept = selectedLevel === "All"
  ? dept.replace(/\s*\(.*?\)\s*$/, "")
  : dept;

const posSeries = labels.map(grp => {
  const g = dataMap[baseDept]?.[grp];
  return g
    ? valueType === "percent" ? g.positive_percent : g.positive_count
    : 0;
});

const negSeries = labels.map(grp => {
  const g = dataMap[baseDept]?.[grp];
  return g
    ? valueType === "percent" ? g.negative_percent : g.negative_count
    : 0;
});


datasets.push({
  label: `${dept} - Positive`,
  data: posSeries,
  backgroundColor: POS_COLOR,
  stack: dept,
  datasetIdKey: `${dept}-positive-${valueType}`,

  // 🔧 FIX
  maxBarThickness: 42,
  categoryPercentage: 0.85,
  barPercentage: 0.9,
});


datasets.push({
  label: `${dept} - Negative`,
  data: negSeries,
  backgroundColor: NEG_COLOR,
  stack: dept,
  datasetIdKey: `${dept}-negative-${valueType}`,

  // 🔧 FIX
  maxBarThickness: 42,
  categoryPercentage: 0.85,
  barPercentage: 0.9,
});


    });

    return { labels, datasets };

}, [selectedDepts, selectedGroups, mode, valueType, dataMap]);


  // ----------------------------
  // CHART OPTIONS
  // ----------------------------
const options = useMemo(() => ({
  responsive: true,
  maintainAspectRatio: false,

  animation: {
    duration: 400,   // keep initial animation
  },

  resizeDelay: 0,    // 🚨 stops resize lag

  transitions: {
    resize: {
      animation: {
        duration: 0, // 🚨 NO animation on resize
      },
    },
  },

  plugins: {
    legend: { position: "bottom" },
  },

  scales: {
    x: {
      stacked: mode === "both",
      offset: true,
    },
    y: {
      beginAtZero: true,
      stacked: mode === "both",
      max: valueType === "percent" ? 100 : undefined,
    },
  },
}), [mode, valueType]);

  // ----------------------------
  // RENDER
  // ----------------------------
  return (
    <div className="dgc-wrapper">

      <div className="dgc-controls">

        {/* LEVEL */}
        <div className="dgc-panel">
          <div className="dgc-panel-title">Level</div>
          <select
            className="dgc-dropdown"
            value={selectedLevel}
            onChange={(e) => setSelectedLevel(e.target.value)}
          >
            {allLevels.map((lvl) => (
              <option key={lvl} value={lvl}>{lvl}</option>
            ))}
          </select>
        </div>

        {/* DEPARTMENTS */}
        <div className="dgc-panel">
          <div className="dgc-panel-title">Departments</div>
          <div className="dgc-btn-row">
            <button className="dgc-btn" onClick={selectAllDepts}>All</button>
            <button className="dgc-btn" onClick={deselectAllDepts}>Clear</button>
          </div>

          <div className="dgc-checkbox-list">
            {departments.map((d) => (
              <label key={d}>
                <input
                  type="checkbox"
                  checked={selectedDepts.includes(d)}
                  onChange={() => toggleDept(d)}
                /> {d}
              </label>
            ))}
          </div>
        </div>

        {/* GROUPS */}
        <div className="dgc-panel">
          <div className="dgc-panel-title">Groups</div>
          <div className="dgc-btn-row">
            <button className="dgc-btn" onClick={selectAllGroups}>All</button>
            <button className="dgc-btn" onClick={deselectAllGroups}>Clear</button>
          </div>

          <div className="dgc-checkbox-list">
            {allGroups.map((g) => (
              <label key={g}>
                <input
                  type="checkbox"
                  checked={selectedGroups.includes(g)}
                  onChange={() => toggleGroup(g)}
                /> {g}
              </label>
            ))}
          </div>
        </div>

        {/* MODE */}
        <div className="dgc-panel">
          <div className="dgc-panel-title">Mode</div>
          <div className="dgc-radio-list">
            <label>
              <input type="radio" checked={mode === "positive"} onChange={() => setMode("positive")} />
              Positive
            </label>
            <label>
              <input type="radio" checked={mode === "negative"} onChange={() => setMode("negative")} />
              Negative
            </label>
            <label>
              <input type="radio" checked={mode === "both"} onChange={() => setMode("both")} />
              Both (Stacked)
            </label>
          </div>
        </div>

        {/* VALUE TYPE */}
<div className="dgc-panel">
  <div className="dgc-panel-title">Values</div>
  <div className="dgc-radio-list">
    <label>
      <input
        type="radio"
        checked={valueType === "percent"}
        onChange={() => setValueType("percent")}
      />
      Percentage (%)
    </label>
    <label>
      <input
        type="radio"
        checked={valueType === "count"}
        onChange={() => setValueType("count")}
      />
      Count
    </label>
  </div>
</div>

      </div>

<div className="dgc-chart-container">
  <Bar data={chartData} options={options} />
</div>
    </div>
  );
}